var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74249 0.307551L11.6924 5.25751C12.1025 5.66757 12.1025 6.33243 11.6924 6.74249L6.74249 11.6924C6.33243 12.1025 5.66757 12.1025 5.25751 11.6924L0.307551 6.74249C-0.102517 6.33243 -0.102517 5.66757 0.307551 5.25751L5.25751 0.307551C5.66757 -0.102517 6.33243 -0.102517 6.74249 0.307551Z",
    fill: "#DA0901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99985 3.04248L4.11377 6.1326H7.85553L5.98465 9.04248",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default __webpack_public_path__ + "static/media/AlarmIcon.d3c3147f02878a41deab1a86457c8a04.svg";
export { ForwardRef as ReactComponent };